import mod from "-!./app_component.js?vue&type=script&lang=js&"; export default mod; export * from "-!./app_component.js?vue&type=script&lang=js&"